import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
const MANUAL_CALL_LOGS_API_URL = "api/call-data/";
const MANUAL_CALL_LOGS_INFO_API_URL = "portfolio/manual-call-logs/";


export const fetchManualCallLogs = createAsyncThunk(
    "cases/fetchManualCallLogs",
    async (params, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;
            if (!token) return;

            const response = await axios.get(MANUAL_CALL_LOGS_API_URL, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                params: params,
            });

            return response?.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch users list"
            );
        }
    }
);

export const fetchManualCallInfo = createAsyncThunk(
    "cases/fetchManualCallInfo",
    async (params, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const token = state.auth.token;
            if (!token) return;

            const response = await axios.get(MANUAL_CALL_LOGS_INFO_API_URL, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                params: params,
            });

            return response?.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch users list"
            );
        }
    }
);




const initialState = {
    manual_call_logs: [],
    manual_call_logs_loading: false,
};

const casesInfoSlice = createSlice({
    name: "casesInfoSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchManualCallLogs.pending, (state) => {
                state.manual_call_logs_loading = true;
            })
            .addCase(fetchManualCallLogs.fulfilled, (state, action) => {
                state.manual_call_logs_loading = false;
                state.manual_call_logs = action.payload;
            })
            .addCase(fetchManualCallLogs.rejected, (state, action) => {
                state.manual_call_logs_loading = false;
                state.manual_call_logs = [];
            })
    },
});

export default casesInfoSlice.reducer;
